import {
  ChangeDetectionStrategy,
  Component,
  inject,
  computed,
} from '@angular/core'
import { RouterModule } from '@angular/router'

import { TypographyComponent } from '@hyperkit'

import { SessionService } from '@hunt/services'
import { HuntViewService, HuntEditorService } from '@hunt/services'

import { ReportTextBlockComponent } from '../report-text-block/report-text-block.component'

@Component({
  standalone: true,
  selector: 'final-report-conclusion',
  imports: [RouterModule, ReportTextBlockComponent, TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './final-report-conclusion.component.html',
  styleUrls: ['final-report-conclusion.component.scss'],
})
export class FinalReportConclusionComponent {
  /** View and editor services for two-way binding */
  readonly huntView = inject(HuntViewService)
  readonly huntEditor = inject(HuntEditorService)
  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )
}
